<div class="agenda-bg">
</div>
<div id="outer_container">
    <div class="container-fluid noPadding">
    <!-- uiView: content -->
        <div
            id="content"
            ui-view="content"
            class="angular-animate ng-scope"
            autoscroll="true"
            mtc-scroll-to-invalid=""
        >
            <!-- video controls -->
            <!-- <div class="video-control">
                <button id="myBtn" class="btn2 btn2-light" onclick="myFunction()"></button>
            </div> -->
            <!-- video controls -->
            <div class="ng-scope">
                <div class="container">
                    <div class="home">
                        <div class="type-container ng-scope">
                            <div class="type-headline">
                                <h1>Agenda</h1>
                            </div>
                            <div class="type-copy">
                                <p>
                                    <strong>Looking Ahead</strong><br>
                                    This preliminary agenda provides a sneak peek at your Golden Eagle Club trip.
                                    Activities and functions are subject to change. Shortly before your departure,
                                    you will receive a detailed digital itinerary. <em>As part of the Golden Eagle Club experience,
                                    honorees and guests are expected to attend all scheduled group events.</em>
                                </p>
                            </div>
                            <div class="type-copy d-flex d-lg-block">
                                <ul ngbNav #nav="ngbNav" [(activeId)]="active" [keyboard]="'changeWithArrows'" class="nav-tabs d-none d-lg-flex">
                                    @if (version() === 'VIP') {
                                    <li class="ms-auto" [ngbNavItem]="1">
                                        <button ngbNavLink>Saturday<br> March 13, 2027</button>
                                        <ng-template ngbNavContent>
                                            <p><strong>Travel Day: Saturday, March 13, 2027</strong><br>
                                            <strong>Note:</strong> Travel arrangements to Monte Carlo vary depending on your country of origin.
                                            Your confirmed flight details will indicate your actual departure date.</p>

                                            <p><strong>Daytime Dress: Travel Attire</strong></p>
                                            <ul>
                                                <li>Depart home city for flight to Nice Côte d’Azur Airport (airport code: NCE)</li>
                                                <li>Arrive in Monte Carlo and transfer to Fairmont Monte Carlo (approximately 35 minutes)</li>
                                            </ul>

                                            <p><strong>Evening Dress: Casual Evening Attire</strong></p>
                                            <ul>
                                                <li>Evening at leisure</li>
                                            </ul>
                                        </ng-template>
                                    </li>
                                    <li [ngbNavItem]="2">
                                        <button ngbNavLink>Sunday<br> March 14, 2027</button>
                                        <ng-template ngbNavContent>
                                            <p><strong>Pre-Day: Sunday, March 14, 2027</strong><br>
                                            <strong>Daytime Dress: Casual Daytime Attire </strong></p>
                                            <ul>
                                                <li>Breakfast at leisure </li>
                                                <li>10:30 AM-12:00 PM Venue walk-through</li>
                                                <li>Lunch at leisure on own (may be expensed*)</li>
                                                <ul>
                                                    <li>*Lunch at leisure is to be expensed back to your zone cost center. Lunch allowance is $75 USD per person.</li>
                                                </ul>
                                                <li>Afternoon at leisure</li>
                                            </ul>


                                            <p><strong>Evening Dress: Smart Evening Attire </strong></p>
                                            <ul>
                                                <li>Off-site executive dinner </li>
                                            </ul>
                                        </ng-template>
                                    </li>
                                    }
                                    <li [class.ms-auto]="version() !== 'VIP'" [ngbNavItem]="3">
                                        <button ngbNavLink>Monday<br> March 15, 2027</button>
                                        <ng-template ngbNavContent>
                                            @if (version() === 'VIP') {
                                            <p><strong>Day One: Monday, March 15, 2027</strong><br>
                                            <strong>Daytime Dress: Casual Daytime Attire</strong></p>
                                            <ul>
                                                <li>7:00-11:00 AM Complimentary breakfast at leisure at Nobu restaurant (room service is not included)</li>
                                                <li>9:00 AM-5:00 PM Awards rehearsal, attendee arrivals, executive meet & greet</li>
                                                <ul>
                                                    <li>Time block for greeting will be provided prior to event</li>
                                                </ul>
                                            </ul>

                                            <p><strong>Evening Dress: Themed Attire – French Riviera Chic</strong></p>
                                            <ul>
                                                <li>5:30-6:30 PM First-timers reception in the Grand Salon</li>
                                                <li>6:30-9:30 PM Welcome to Monte Carlo dinner in Terrasse Panoramique & Amù at Fairmont Monte Carlo </li>
                                            </ul>
                                            } @else {
                                            <p><strong>Day One: Monday, March 15, 2027</strong><br>
                                            <strong>Note:</strong> Travel arrangements to Monte Carlo vary depending on your country of origin.
                                            Your confirmed flight details will indicate your actual departure date.</p>

                                            <p><strong>Daytime Dress: Travel Attire/Casual Daytime Attire</strong></p>
                                            <ul>
                                                <li>Depart home city for flight to Nice Côte d’Azur Airport (airport code: NCE)</li>
                                                <li>Arrive in Monte Carlo and transfer to Fairmont Monte Carlo (approximately 35 minutes)</li>
                                                <li>4:00 PM Hotel check-in</li>
                                                <li>Afternoon at leisure / Lunch at leisure for early arrivals (may be expensed*)</li>
                                                <ul>
                                                    <li>*Lunch at leisure is to be expensed back to your zone cost center. Lunch allowance is $75 USD per person.</li>
                                                </ul>
                                            </ul>

                                            <p><strong>Evening Dress: Themed Attire – French Riviera Chic</strong></p>
                                            <ul>
                                                <li>First-timers reception (by invitation only) in the Grand Salon</li>
                                                <li>Welcome to Monte Carlo dinner in Terrasse Panoramique & Amu Monte Carlo</li>
                                            </ul>
                                            }
                                        </ng-template>
                                    </li>
                                    <li [ngbNavItem]="4">
                                        <button ngbNavLink>Tuesday<br> March 16, 2027</button>
                                        <ng-template ngbNavContent>
                                            <p><strong>Day Two: Tuesday, March 16, 2027</strong><br>
                                            <strong>Daytime Dress: Casual Daytime Attire</strong></p>
                                            <ul>
                                                <li>Awards breakfast in Salle d’Or</li>
                                                <li>Day in the city your way or day at leisure</li>
                                                <li>Lunch at leisure on own (may be expensed*)</li>
                                                <ul>
                                                    <li>*Lunch at leisure is to be expensed back to your zone cost center. Lunch allowance is $75 USD per person.</li>
                                                </ul>
                                            </ul>

                                            <p><strong>Evening Dress: Smart Attire </strong></p>
                                            <ul>
                                                @if (version() !== 'EDA') {
                                                <li>GSCS off-site dinner </li>
                                                <ul>
                                                    <li>Americas – Vesta Twiga</li>
                                                    <li>EMEA – A’Trego</li>
                                                    <li>APAC – Circe</li>
                                                </ul>
                                                }
                                                @if (version() !== 'GSCS') {
                                                <li>{{ version() === 'VIP' ? 'EDA off-site Dine Your Way' : 'Off-site Dine Your Way' }} </li>
                                                <ul>
                                                    <li>Refer to the Dining tab for restaurant information. You will be select your Monte Carlo restaurant of preference from the options provided during registration.</li>
                                                </ul>
                                                }
                                            </ul>
                                        </ng-template>
                                    </li>
                                    <li [ngbNavItem]="5">
                                        <button ngbNavLink>Wednesday<br> March 17, 2027</button>
                                        <ng-template ngbNavContent>
                                            <p><strong>Day Three: Wednesday, March 17, 2027</strong><br>
                                            <strong>Daytime Dress: Sportswear According to Your Selected Activity</strong></p>
                                            <ul>
                                                <li>7:00-11:00 AM Complimentary breakfast at leisure at Nobu restaurant (room service is not included)</li>
                                                <li>Choice of sponsored activities or day at leisure</li>
                                                <li>Lunch in conjunction with sponsored activity OR at leisure (may be expensed*)</li>
                                                <ul>
                                                    <li>*Lunch at leisure is to be expensed back to your zone cost center. Lunch allowance is $75 USD per person.</li>
                                                </ul>
                                            </ul>

                                            <p><strong>Evening Dress: Smart Attire </strong></p>
                                            <ul>
                                                @if (version() !== 'EDA') {
                                                <li>{{ version() === 'VIP' ? 'GSCS off-site dine your way' : 'Off-site dine your way' }}</li>
                                                <ul>
                                                    <li>Refer to the Dining tab for restaurant information. You will be select your Monte Carlo restaurant of preference from the options provided during registration.</li>
                                                </ul>
                                                }
                                                @if (version() !== 'GSCS') {
                                                <li>{{ version() === 'VIP' ? 'EDA off-site dinner at Vesta Twiga' : 'Off-site dinner at Vesta Twiga' }}</li>
                                                }
                                            </ul>
                                        </ng-template>
                                    </li>
                                    <li [ngbNavItem]="6">
                                        <button ngbNavLink>Thursday<br> March 18, 2027</button>
                                        <ng-template ngbNavContent>
                                            <p><strong>Day Four: Thursday, March 18, 2027</strong><br>
                                            <strong>Daytime Dress: Sportswear According to Your Selected Activity   </strong></p>
                                            <ul>
                                                <li>7:00-11:00 AM Complimentary breakfast at leisure at Nobu restaurant (room service is not included)</li>
                                                <li>Choice of sponsored activities or day at leisure</li>
                                                <li>Lunch in conjunction with sponsored activity OR at leisure (may be expensed*)</li>
                                                <ul>
                                                    <li>*Lunch at leisure is to be expensed back to your zone cost center. Lunch allowance is $75 USD per person.</li>
                                                </ul>
                                            </ul>

                                            <p><strong>Evening Dress: Masquerade Ball Cocktail Chic Evening Attire</strong></p>
                                            <ul>
                                                <li>Standing reception at Oceano Museum</li>
                                            </ul>

                                        </ng-template>
                                    </li>
                                    <li [ngbNavItem]="7">
                                        <button ngbNavLink>Friday<br> March 19, 2027</button>
                                        <ng-template ngbNavContent>
                                            <p><strong>Day Five: Friday, March 19, 2027</strong><br>
                                            <strong>Daytime Dress: Casual Daytime Attire</strong></p>
                                            <ul>
                                                <li>7:00 AM-11:00 AM Breakfast at leisure at Nobu restaurant (room service is not included) </li>
                                                <li>Day in the city your way or day at leisure</li>
                                                <li>Lunch at leisure on own (may be expensed*)</li>
                                                <ul>
                                                    <li>*Lunch at leisure is to be expensed back to your zone cost center. Lunch allowance is $75 USD per person.</li>
                                                </ul>
                                            </ul>

                                            <p><strong>Evening Dress: Themed Attire – James Bond Casino, <em>Black Tie Encouraged</em></strong></p>
                                            <ul>
                                                <li>5:30 PM-6:30 PM Worldwide Award Winner reception (by invitation only)</li>
                                                <li>6:30 PM-9:30 PM Final night dinner at Salle d’Or & Galerie Cristal</li>
                                                <li>9:30 PM-12:00 AM Late night casino and dance party in the Grand Salon</li>
                                            </ul>
                                        </ng-template>
                                    </li>
                                    <li class="me-auto" [ngbNavItem]="8">
                                        <button ngbNavLink>Saturday<br> March 20, 2027</button>
                                        <ng-template ngbNavContent>
                                            <p><strong>Day Six: Saturday, March 20, 2027</strong><br>
                                            <strong>Daytime Dress: Travel Attire </strong></p>
                                            <ul>
                                                <li>7:00-11:00 AM Complimentary breakfast at leisure at Nobu restaurant (room service is not included)</li>
                                                <li>Hotel checkout (checkout time is 10:00 AM) </li>
                                                <li>Transfer to Nice Côte d’Azur Airport </li>
                                            </ul>
                                            <p><strong>Note: Please refer to your Departure Notice for specific departure information.</strong></p>

                                            <ul>
                                                <li>Departure flight to home city </li>
                                                <li>Customs Formalities: Once you arrive in your home country, you will pass through Immigration and Customs formalities before proceeding to your connecting flight or final destination. </li>
                                            </ul>
                                        </ng-template>
                                    </li>
                                </ul>
                                <div ngbNav #nav="ngbNav" [(activeId)]="active" [keyboard]="'changeWithArrows'" class="nav-pills flex-column d-flex d-lg-none" orientation="vertical">
                                    @if (version() === 'VIP') {
                                        <ng-container [ngbNavItem]="1">
                                            <button ngbNavLink>Saturday<br>March 13, 2027</button>
                                            <ng-template ngbNavContent>
                                            </ng-template>
                                        </ng-container>
                                        <ng-container [ngbNavItem]="2">
                                            <button ngbNavLink>Sunday<br>March 14, 2027</button>
                                            <ng-template ngbNavContent>
                                            </ng-template>
                                        </ng-container>
                                    }
                                    
                                    <ng-container [ngbNavItem]="3">
                                        <button ngbNavLink>Monday<br>March 15, 2027</button>
                                        <ng-template ngbNavContent>
                                        </ng-template>
                                    </ng-container>
                                    <ng-container [ngbNavItem]="4">
                                        <button ngbNavLink>Tuesday<br>March 16, 2027</button>
                                        <ng-template ngbNavContent>
                                        </ng-template>
                                    </ng-container>
                                    <ng-container [ngbNavItem]="5">
                                        <button ngbNavLink>Wednesday<br>March 17, 2027</button>
                                        <ng-template ngbNavContent>
                                        </ng-template>
                                    </ng-container>
                                    <ng-container [ngbNavItem]="6">
                                        <button ngbNavLink>Thursday<br>March 18, 2027</button>
                                        <ng-template ngbNavContent>
                                        </ng-template>
                                    </ng-container>
                                    <ng-container [ngbNavItem]="7">
                                        <button ngbNavLink>Friday<br>March 19, 2027</button>
                                        <ng-template ngbNavContent>
                                        </ng-template>
                                    </ng-container>
                                    <ng-container [ngbNavItem]="8">
                                        <button ngbNavLink>Saturday<br>March 20, 2027</button>
                                        <ng-template ngbNavContent>
                                        </ng-template>
                                    </ng-container>
                                </div>
                                <div [ngbNavOutlet]="nav" class="mt-2"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
